<template>
  <v-footer absolute app color="background">
    <v-spacer />
    <v-btn
      v-for="link in links"
      :key="link.link"
      variant="text"
      size="small"
      class="on-background"
      :href="link.link"
      target="_blank"
    >
      {{ t(`components.footer.${link.name}`) }}
    </v-btn>
    <v-btn
      variant="text"
      size="small"
      class="on-background"
      @click="$CookieConsent.showPreferences()"
    >
      {{ t("components.footer.cookies") }}
    </v-btn>
    <v-spacer />
  </v-footer>
</template>

<script setup lang="ts">
import { inject, reactive } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const links = reactive([
  { name: "terms", link: "https://yetipay.me/terms" },
  { name: "privacy", link: "https://yetipay.me/privacy" },
]);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $CookieConsent = inject<any>("CookieConsent");
</script>
